import { Outlet, useMatch } from 'react-router-dom';

import { PostHogPageView } from '@/components/analytics/PostHogPageView';

/**
 * The buyer routes sit outside RootLayout, so pageview capture is mounted here instead — except on
 * the quote route itself, where the page sends its own pageview once the quote id is registered
 * (`useCustomerSurfaceQuote`). Capturing in both places would double-count it.
 */
export default function CustomerSurfaceLayout() {
  const quoteRoute = useMatch('/q/:token');

  return (
    <>
      {!quoteRoute && <PostHogPageView />}
      <Outlet />
    </>
  );
}
